import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
// import Stack from "@mui/material/Stack";
import useTheme from "@mui/material/styles/useTheme";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import { Link } from "react-router-dom"; // Import Link for navigation
// import DateRangeIcon from "@mui/icons-material/DateRange";

function Blogs() {
  const [blogPosts, setBlogPosts] = useState([]);
  const theme = useTheme();

  useEffect(() => {
    // Fetch blog posts from the API with _embed parameter
    const fetchBlogPosts = async () => {
      try {
        const response = await fetch(
          "https://www.directcertify.com/blog/wp-json/wp/v2/posts?per_page=3&_embed"
        );
        const data = await response.json();
        setBlogPosts(data);
      } catch (error) {
        console.error("Error fetching blog posts:", error);
      }
    };

    fetchBlogPosts();
  }, []);

  return (
    <Box sx={{ my: 5 }}>
      <Container>
        <Typography
          sx={{
            textAlign: "center",
            fontSize: "52px",
            fontFamily: "Poppins",
            fontWeight: 700,
          }}
        >
          Our Blog
        </Typography>

        <Grid container columnGap={5} rowGap={5} sx={{ my: 5 }}>
          {blogPosts.map((post) => (
            <Grid item key={post.id} md={3.7} xs={12}>
              <Card>
                {post._embedded && post._embedded["wp:featuredmedia"] && (
                  <CardMedia
                    component="img"
                    height="300"
                    image={
                      post._embedded["wp:featuredmedia"][0].media_details.sizes
                        .medium.source_url || "https://via.placeholder.com/300"
                    }
                    alt=""
                  />
                )}
                <CardContent
                  sx={{
                    borderRadius: "0px 0px 15px 5px",
                  }}
                >
                  <Link
                    to={post.link}
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Typography
                      component="span" // Changed from default 'p' to 'span'
                      sx={{
                        display: "block", // Added to maintain block behavior
                        textAlign: "center",
                        fontSize: "24px",
                        fontFamily: "Poppins",
                        fontWeight: 700,
                        color: "#1A1F22",
                        [theme.breakpoints.up("md")]: {
                          minHeight: "180px",
                          padding: "2rem 0",
                          display: "flex",
                          alignItems: "center",
                        },
                      }}
                    >
                      {
                        new DOMParser().parseFromString(
                          post.title.rendered,
                          "text/html"
                        ).body.textContent
                      }
                    </Typography>
                  </Link>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box display={"flex"} justifyContent={"center"}>
          <Link
            to="https://www.directcertify.com/blog/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <Button
              variant="contained"
              sx={{
                fontSize: "16px",
                textTransform: "none",
                borderRadius: "5px",
                background: "#27B1BB !important",
              }}
            >
              Read More
            </Button>
          </Link>
        </Box>
      </Container>
    </Box>
  );
}

export default Blogs;
